import React from 'react';
import { useTranslation } from 'react-i18next';
import { Table, DropdownSort, DropdownItem } from '@weezevent/nacre';

export default function TicketOfficeEventTab({ children, order, setOrder, selectAll, setSelectAll, setSelected }) {
    const { t } = useTranslation();

    return (
        <Table
            basic
            celled
            useNew
            selectable
            onSelectAll={(_, data) => {
                setSelectAll(!selectAll);
                selectAll === true ? setSelected([]) : setSelectAll(true);
            }}
        >
            <Table.THead>
                <Table.Tr isHeader active={selectAll}>
                    <th style={{ width: '170px' }}>
                        <DropdownSort
                            name="crst"
                            active={['crst', `-crst`].includes(order)}
                            label={t('ticket.ticket_offices.events.table.date')}
                            ordering={order}
                            items={[
                                <DropdownItem.Icons
                                    key={1}
                                    item={t('ticket.common.ordering.ascending')}
                                    checked={order === 'crst'}
                                    onClick={() => {
                                        setOrder('crst');
                                    }}
                                />,
                                <DropdownItem.Icons
                                    key={2}
                                    item={t('ticket.common.ordering.descending')}
                                    checked={order === '-crst'}
                                    onClick={() => {
                                        setOrder('-crst');
                                    }}
                                />
                            ]}
                        />
                    </th>
                    <th style={{ width: '140px' }}>
                        <DropdownSort
                            name="id"
                            active={['id', `-id`].includes(order)}
                            label={t('ticket.ticket_offices.events.table.id')}
                            ordering={order}
                            items={[
                                <DropdownItem.Icons
                                    key={1}
                                    item={t('ticket.common.ordering.ascending')}
                                    checked={order === 'id'}
                                    onClick={() => {
                                        setOrder('id');
                                    }}
                                />,
                                <DropdownItem.Icons
                                    key={2}
                                    item={t('ticket.common.ordering.descending')}
                                    checked={order === '-id'}
                                    onClick={() => {
                                        setOrder('-id');
                                    }}
                                />
                            ]}
                        />
                    </th>
                    <th style={{ width: '280px' }}>
                        <DropdownSort
                            name="alpha"
                            active={['alpha', `-alpha`].includes(order)}
                            ordering={order}
                            label={t('ticket.ticket_offices.events.table.event')}
                            items={[
                                <DropdownItem.Icons
                                    key={1}
                                    item={t('ticket.common.ordering.A-Z')}
                                    checked={order === 'alpha'}
                                    onClick={() => {
                                        setOrder('alpha');
                                    }}
                                />,
                                <DropdownItem.Icons
                                    key={2}
                                    item={t('ticket.common.ordering.Z-A')}
                                    checked={order === '-alpha'}
                                    onClick={() => {
                                        setOrder('-alpha');
                                    }}
                                />
                            ]}
                        />
                    </th>
                    <th>{t('ticket.ticket_offices.events.table.rates')}</th>
                    <th>{t('ticket.ticket_offices.events.table.quota')}</th>
                    <th>{t('ticket.ticket_offices.events.table.visible')}</th>
                    <th style={{ width: '100px' }}>{t('ticket.ticket_offices.events.table.actions')}</th>
                </Table.Tr>
            </Table.THead>
            <Table.TBody>{children}</Table.TBody>
        </Table>
    );
}
